<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Publication Type</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-data-table :headers="headers" :items="publication_type_list" class="elevation-1 mytable" dense
        :search="search">
        <template v-slot:top>
          <v-toolbar flat dense color="white">
            <!-- <v-toolbar-title>Fees Component</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider> -->
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="button" v-on="on">Add Publication Type</v-btn>
              </template>
              <v-card>
                <v-card-title class="toolbar">
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-autocomplete dense rounded outlined :items="publication_type_super_master_list"
                          v-model="addedItem.publication_type" label="Select Publication Type"></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field v-model="editedItem.publication_type" dense rounded outlined persistent-hint
                          :disabled="editedIndex != -1" hint="
                            noneditable
                          " label="Publication Type"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                        <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="button" @click="close">Cancel</v-btn>
                  <v-btn class="button" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
          <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
        </template>
        <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    overlay: false,
    errorMsg: {
      publication_type: false,
    },
    snackbar_msg: "",

    // extraBreadcrumbItems: [
    //   { text: "Publication Type", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    publication_type_super_master_list: null,
    headers: [
      {
        text: "Publication Type",
        align: "left",
        sortable: false,
        value: "publication_type",
      },
      {
        text: "Active",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    publication_type_list: [],
    editedIndex: -1,
    addedItem: {
      publication_type: "",
    },
    editedItem: {
      id: "",
      publication_type: "",
      isactive: true,
    },
    defaultItem: {
      id: "",
      publication_type: "",
      isactive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Publication Type"
        : "Edit Publication Type";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },
  methods: {
    initializeErrorMsgFalse() {
      this.errorMsg.publication_type = false;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/RoleManagement/getPublicationType")
        .then((res) => {
          if (res.data.msg == "200") {
            this.overlay = false;
            this.publication_type_super_master_list =
              res.data.publication_type_super_master_list;
            this.publication_type_list = res.data.publication_type_list;
            this.load = true;
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          "use strict";
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.publication_type_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    // deleteItem (item) {
    //   const index = this.publication_type_super_master_list.indexOf(item)
    //   confirm('Are you sure you want to delete this item?') && this.publication_type_super_master_list.splice(index, 1)
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/RoleManagement/editPublicationType", this.editedItem)
            .then((res) => {
              if (res.data.msg == "200") {
                Object.assign(
                  this.publication_type_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar(
                  "#4caf50",
                  "Publication Type updated successfully..."
                ); // show snackbar on success
              }
            })
            .catch((error) => {
              window.console.log(error);
            })
            .finally(() => {
              this.addedItem.publication_type = "";
            });

          this.close();
        }
      } else {
        axios
          .post("/RoleManagement/savePublicationType", this.addedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.publication_type_list.push(this.addedItem);
              this.showSnackbar(
                "#4caf50",
                "Publication Type added successfully..."
              ); // show snackbar on success
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar(
                "#b71c1c",
                "Publication Type already present!!!"
              ); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          })
          .finally(() => {
            this.addedItem.publication_type = "";
          });

        this.close();
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.publication_type) {
        return true;
      } else {
        if (!this.editedItem.publication_type) {
          this.errorMsg.publication_type = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>
